import { render, staticRenderFns } from "./CreateEscalationMatrix.vue?vue&type=template&id=10ae367d"
import script from "./CreateEscalationMatrix.vue?vue&type=script&lang=js"
export * from "./CreateEscalationMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports